
import { BaseModel } from './base.model';

export class SiteModel extends BaseModel{
  id:number;
    companyId:number;
    siteName:string;
    address:string;
    city: string;
    stateProvince: string;
    postalZipCode:string;
    country:string;
    sitename:string;
    latitude:string;
    longitude:string;
    isDefaultSite?: boolean | number;
    IsDefaultSite?: boolean | number;
}
